import { ActionGlyph } from '../../components/ActionGlyph'
import { publicUrl } from '../../routing/basePath'
import { useAppState } from '../../state/AppProvider'
import { AccountScaffold } from './AccountScaffold'

interface WelcomePageProps {
  navigate: (to: string) => void
}

export function WelcomePage({ navigate }: WelcomePageProps) {
  const state = useAppState()
  const canContinue = Boolean(state.user && state.session)

  return (
    <AccountScaffold
      className="welcome-page"
      eyebrow="The Paradox · Show night"
      title="Get in. Find your show."
      intro="Connect your ticket, find your city, and keep the mark after the lights come up."
      headerMedia={(
        <picture>
          <source media="(min-width: 800px)" srcSet={publicUrl('assets/the-paradox-band-hero-1440.jpg')} />
          <img
            alt="The Paradox band together in a wood-paneled room"
            decoding="async"
            fetchPriority="high"
            height="540"
            src={publicUrl('assets/the-paradox-band-hero-960.jpg')}
            width="960"
          />
        </picture>
      )}
    >
      <div className="access-actions">
        {canContinue ? (
          <button className="access-primary" type="button" onClick={() => navigate('/home')}>
            Continue as {state.user?.displayName}
            <ActionGlyph />
          </button>
        ) : (
          <>
            <button className="access-primary" type="button" onClick={() => navigate('/auth/create')}>
              Create account
              <ActionGlyph />
            </button>
            <button className="access-secondary" type="button" onClick={() => navigate('/auth/sign-in')}>
              Sign in
              <ActionGlyph />
            </button>
            <button className="access-secondary access-browse-action" type="button" onClick={() => navigate('/tour')}>
              Browse without an account
              <ActionGlyph />
            </button>
            <p className="access-hint access-browse-note">Explore tour stops, the Tour Desk, and official links. Sign in only when you want to save or take part.</p>
          </>
        )}
        <button className="access-text-button public-support-link" type="button" onClick={() => navigate('/support')}>
          Help and Support
        </button>
      </div>

      <hr className="access-divider" />

      <section className="access-section" aria-labelledby="welcome-route-heading">
        <h2 id="welcome-route-heading">Start with the ticket</h2>
        <ol className="welcome-steps">
          <li>
            <span>01</span>
            <div><strong>Get in</strong><p>Add any ticket code and put your stop up front.</p></div>
          </li>
          <li>
            <span>02</span>
            <div><strong>Find the city</strong><p>See the stop, the plan, and what fans are posting.</p></div>
          </li>
          <li>
            <span>03</span>
            <div><strong>Keep the mark</strong><p>Check in and add the night to your passport.</p></div>
          </li>
        </ol>
      </section>
    </AccountScaffold>
  )
}
